import apiClient from '../../config/axios';

export const paypalPaymentService = {
  // INIZIO: CREO UN PAGAMENTO CON PAYPAL - CONTATTO IL SERVER - RITORNA UN URL
  createPayPalOrder: async (membershipListId) => {
    try {
      // console.log('Frontend: Creating PayPal order for:', membershipListId);
      
      const response = await apiClient.post('/api/memberships/create-paypal-order', {
        membershipListId
      });
      
      // console.log('Frontend: PayPal order response:', response.data);
      return { success: true, ...response.data };
    } catch (error) {
      console.error('Frontend: PayPal order creation error:', error);
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  // VADO ALL'URL DI PAYPAL
  redirectToPayPal: async (approvalUrl) => {
    try {
      console.log('Frontend: Redirecting to PayPal:', approvalUrl);
      // Redirect to PayPal
      window.location.href = approvalUrl;
      return { success: true };
    } catch (error) {
      console.error('Frontend: PayPal redirect error:', error);
      return { success: false, error: error.message };
    }
  },

  // DOPO IL PAGAMENTO (TESSERAMENTO) DEVO INVIARE LE INFO AL SERVER
  capturePayPalOrder: async (orderId) => {
    try {
      // console.log('Frontend: Capturing PayPal order:', orderId);
      
      const response = await apiClient.post('/api/memberships/capture-paypal-order', {
        orderId
      });
      
      // console.log('Frontend: PayPal capture response:', response.data);
      return { success: true, ...response.data };
    } catch (error) {
      console.error('Frontend: PayPal capture error:', error);
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  // Course-specific functions
  createPayPalCourseOrder: async (courseData) => {
    try {
      console.log('Frontend: Creating PayPal course order for:', courseData);
      
      const response = await apiClient.post('/api/enrollments/create-paypal-order-new-course', {
        courseData
      });
      
      console.log('Frontend: PayPal course order response:', response.data);
      return { success: true, ...response.data };
    } catch (error) {
      console.error('Frontend: PayPal course order creation error:', error);
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  capturePayPalCourseOrder: async (orderId) => {
    try {
      console.log('Frontend: Capturing PayPal course order:', orderId);
      
      const response = await apiClient.post('/api/enrollments/capture-paypal-course', {
        orderId
      });
      
      console.log('Frontend: PayPal course capture response:', response.data);
      return { success: true, ...response.data };
    } catch (error) {
      console.error('Frontend: PayPal course capture error:', error);
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  createPayPalUpkeepOrder: async (courseData) => {
    try {
      console.log('Frontend: Creating PayPal upkeep order for:', courseData);
      
      const response = await apiClient.post('/api/enrollments/create-paypal-order-upkeep-course', {
        courseData
      });
      
      console.log('Frontend: PayPal upkeep order response:', response.data);
      return { success: true, ...response.data };
    } catch (error) {
      console.error('Frontend: PayPal upkeep order creation error:', error);
      return { success: false, error: error.response?.data?.message || error.message };
    }
  },

  capturePayPalUpkeepOrder: async (orderId) => {
    try {
      console.log('Frontend: Capturing PayPal upkeep order:', orderId);
      
      const response = await apiClient.post('/api/enrollments/capture-paypal-upkeep', {
        orderId
      });
      
      console.log('Frontend: PayPal upkeep capture response:', response.data);
      return { success: true, ...response.data };
    } catch (error) {
      console.error('Frontend: PayPal upkeep capture error:', error);
      return { success: false, error: error.response?.data?.message || error.message };
    }
  }
};
